var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9364,
    cy: 25.0222,
    rx: 21.8938,
    ry: 21.8938,
    fill: "#F2F0FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5166 33.9505L6.57047 35.7944L8.39917 34.7318L7.3453 32.8879L5.5166 33.9505Z",
    fill: "#515B60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1256 9.25925L14.0718 7.44678L12.2431 8.50935L13.2969 10.3218L15.1256 9.25925Z",
    fill: "#515B60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36834 15.3229L6.53964 14.2603L5.48578 16.1042L7.31448 17.1668L8.36834 15.3229Z",
    fill: "#515B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.273 41.5458L14.1017 42.6084L15.1556 40.7645L13.3269 39.7019L12.273 41.5458Z",
    fill: "#515B60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3869 16.1046L39.3327 14.2607L37.5351 15.3233L38.5889 17.1672L40.3869 16.1046Z",
    fill: "#515B60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25588 23.9771H3.06592V26.1852H5.25588V23.9771Z",
    fill: "#515B60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.476 34.7313L39.3047 35.7939L40.3586 33.95L38.5299 32.8874L37.476 34.7313Z",
    fill: "#515B60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7472 9.25925L32.5758 10.3532L33.6296 8.50935L31.801 7.44678L30.7472 9.25925Z",
    fill: "#515B60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4853 23.9771H40.2954V26.1852H42.4853V23.9771Z",
    fill: "#515B60"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8728 25.043C45.8728 18.6468 43.6359 13.193 39.1623 8.68213C35.5282 5.01831 31.2771 2.84193 26.4092 2.1543C27.1227 1.92598 27.5563 1.62699 27.5563 1.29974C27.5563 0.582077 25.4741 0 22.9057 0C20.3373 0 18.2551 0.582077 18.2551 1.30018C18.2551 1.63052 18.6962 1.93172 19.4219 2.16093C14.5712 2.85518 10.334 5.02891 6.71049 8.68257C2.23639 13.1934 0 18.6472 0 25.043C0 31.4397 2.23639 36.893 6.71049 41.4039C9.5062 44.2233 12.6672 46.1612 16.1935 47.2184C12.9186 47.3938 10.7676 47.6897 10.7676 48.0249C10.7676 48.5632 16.313 49 23.1541 49C29.9946 49 35.5405 48.5637 35.5405 48.0249C35.5405 47.6769 33.2218 47.3712 29.734 47.1986C33.238 46.1351 36.381 44.199 39.1623 41.388C43.6359 36.8674 45.8728 31.4189 45.8728 25.043ZM22.9364 46.639C17.0265 46.639 11.9795 44.5293 7.79496 40.3104C3.61081 36.0914 1.51852 31.0024 1.51852 25.0434C1.51852 19.0849 3.61081 13.9955 7.79496 9.7765C11.9795 5.55711 17.0261 3.44786 22.9364 3.44786C28.8458 3.44786 33.8932 5.55755 38.0774 9.7765C42.2615 13.9955 44.3538 19.0849 44.3538 25.0434C44.3538 31.0024 42.2615 36.0914 38.0774 40.3104C33.8932 44.5293 28.8458 46.639 22.9364 46.639Z",
    fill: "#515B60"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6516 42.5249H21.8996V44.7331H23.6516V42.5249Z",
    fill: "#515B60"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8966 31.7639L23.6516 24.7322V9.84641H25.6331L22.9364 4.43945L20.2707 9.84641H21.0236V21.669L19.4429 22.5757L21.0236 25.3571V27.5119H23.6183L26.1289 32.4039L24.7961 33.4435L29.7861 36.8856L29.3376 30.9182L27.8966 31.7639Z",
    fill: "#515B60"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7472 40.7628L31.801 42.6066L33.5989 41.544L32.5451 39.7002L30.7472 40.7628Z",
    fill: "#515B60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgClock);
export default __webpack_public_path__ + "static/media/Lg_clock.50616c15.svg";
export { ForwardRef as ReactComponent };